/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WaitlistUnsubscribeRequest interface.
 */
export function instanceOfWaitlistUnsubscribeRequest(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function WaitlistUnsubscribeRequestFromJSON(json) {
    return WaitlistUnsubscribeRequestFromJSONTyped(json, false);
}
export function WaitlistUnsubscribeRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
export function WaitlistUnsubscribeRequestToJSON(json) {
    return WaitlistUnsubscribeRequestToJSONTyped(json, false);
}
export function WaitlistUnsubscribeRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
